<template>
    <div class="app-header" v-if="projectId && data.title">
        <div class="navigation">
            <div class="vertical-container__content">
                <ul class="navigation-list navigation-list--main-header">
                    <li class="navigation-list__item">
                        <router-link :to="{ name: 'project-detail', params: { projectId }}"
                                     class="navigation-list__link navigation-title">
                            {{ data.title }}
                        </router-link>
                        <ul v-if="projectId === projectId" class="navigation-sublist">
                            <li class="navigation-sublist__item">
                                <router-link :to="{ name: 'project-unit-default', params: { projectId }}"
                                             class="navigation-sublist__link">
                                    Jednotky
                                </router-link>
                            </li>
                            <li class="navigation-sublist__item">
                                <router-link :to="{ name: 'project-option', params: { projectId }}"
                                             class="navigation-sublist__link">
                                    Přizpůsobení
                                </router-link>
                            </li>
                            <li class="navigation-sublist__item">
                                <router-link :to="{ name: 'project-customer-default', params: { projectId }}"
                                             class="navigation-sublist__link">
                                    Zákazníci
                                </router-link>
                            </li>
                            <li class="navigation-sublist__item">
                                <router-link :to="{ name: 'project-extension', params: { projectId }}"
                                             class="navigation-sublist__link">
                                    Rozšíření
                                </router-link>
                            </li>
                            <li class="navigation-sublist__item" v-if="siteId">
                                <a :href="$dmv.env.EDITOR_DOMAIN + '/' + siteId"
                                   class="navigation-sublist__link">
                                    Webová prezentace
                                </a>
                            </li>
                            <li class="navigation-sublist__item" v-else>
                                <router-link :to="{ name: 'project-site-default', params: { projectId }}"
                                             class="navigation-sublist__link">
                                    Webová prezentace
                                </router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

            <div class="vertical-container__footer main-project-footer" style="display: none">
                <div class="button-fix button-create-project-main">
                    <custom-button @click="create" primary small outline>
                        Vytvořit projekt
                    </custom-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CreateProjectDialog from '../CreateProjectDialog';
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    name:       'ProjectNav',
    components: {CustomButton},
    computed:   {
        projectId() {
            return this.$store.getters['projects/project/projectId'];
        },
        data() {
            return this.$store.getters['projects/project/data'];
        },
        siteId() {
            return this.$store.getters['projects/project/siteId'];
        }
    },
    methods:    {
        create() {
            this.$modal.show(CreateProjectDialog, {}, defaultModalParameters());
        },
    }
}
</script>
